import {
  getKeirinHelpArticleUrl,
  getKeirinHelpSubcategoryUrl,
  getToretaHelpArticleUrl,
  toretaHelpUrl,
} from '@/lib/dmm/help';

export const TORETA_HELP_URL = toretaHelpUrl;
export const WALLET_HELP_URL = getKeirinHelpSubcategoryUrl(900);
export const TORETA_PAY_HELP_URL = getToretaHelpArticleUrl(46418);
export const PAYOUT_BANK_HELP_URL = getKeirinHelpArticleUrl(46115);
